var WorkspaceMemberships = require('./gen/workspace_memberships');

module.exports = WorkspaceMemberships;
